var _style, _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetupDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 56",
    style: {
      enableBackground: "new 0 0 50 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#B4CCDD;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 26,
    className: "st0",
    width: 8,
    height: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11,22v8h8v-8H11z M17,28h-4v-4h4V28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31,22v8h8v-8H31z M37,28h-4v-4h4V28z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 17,
    className: "st1",
    width: 2,
    height: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 17,
    className: "st1",
    width: 2,
    height: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 17,
    className: "st1",
    width: 2,
    height: 7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 32,
    className: "st1",
    width: 2,
    height: 7
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 32,
    className: "st1",
    width: 2,
    height: 7
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 36,
    className: "st0",
    width: 2,
    height: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetupDefault);
export default __webpack_public_path__ + "static/media/setup-default.30d6db93685b19923b84d1d18037015c.svg";
export { ForwardRef as ReactComponent };